import {Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { iconsConsideration } from '@tae/constants';

interface ConsiderationInterface {
  description: string,
  pathIcon: string
}

@Component({
    selector: 'app-dialog-consideration',
    templateUrl: './dialog-consideration.component.html',
    styleUrls: ['./dialog-consideration.component.scss'],
    standalone: false
})
export class DialogConsiderationComponent implements OnInit {

  public data: any;

  public icons: any = iconsConsideration

  @Input() considerations: ConsiderationInterface[];

  @Input() title: string;

  @Input() closeIcon: string;

  @Output() close = new EventEmitter<boolean>();

  public closeDialog(dataClose: boolean){
    this.close.emit(dataClose);
    if (this.data?.close) {
      this.data.close();
    }
  }

  ngOnInit() {
    if (this.data) {
      this.considerations = this.data.considerations;
      this.title = this.data.title;
      this.closeIcon = this.data.closeIcon;
    }
  }
}
